import { lazy } from 'react';

const JobList = lazy(() => import('./list/page.js').then((module) => ({ default: module.JobListPage })));
const JobDetail = lazy(() =>
  import('./detail/[id].js').then((module) => ({ default: module.JobDetailPage })),
);
const JobCreate = lazy(() =>
  import('./create/page.js').then((module) => ({ default: module.JobCreatePage })),
);
const JobExample = lazy(() =>
  import('./example/page.js').then((module) => ({ default: module.JobExamplePage })),
);

export { JobCreate, JobDetail, JobExample, JobList };
